angular.module('ad3').directive 'd3AxisLabel', ->
  defaults = ->
    orientation: "bottom"
    align: "middle"
    radius: 30

  restrict: 'A'
  require: '^d3Chart'
  link: ($scope, $el, $attrs, chartController) ->
    options = angular.extend(defaults(), $attrs)
    return unless scale = chartController.getScale(options.axis)
    chart = chartController.getChart()
    redraw = (data) ->
      return unless (value = $scope.$eval(options.value))?
      if options.orientation is 'bottom' or options.orientation is 'top'
        position = "left"
        if options.align is "middle"
          location = scale(value) - $el.width()/2
        if options.align is "right"
          location = scale(value) - $el.width()
        if options.align is "left"
          location = scale(value)
      else
        position = "top"
        if options.align is "middle"
          location = scale(value) - $el.height()/2
        if options.align is "bottom"
          location = scale(value) - $el.height()
        if options.align is "top"
          location = scale(value)

      $el.css(position, location)

    chartController.registerElement(redraw)
